import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from "./BSC-Logo.png";
import Panel from './components/Panel/Panel';
import { Button, Modal, Tab, Tabs, Table } from "react-bootstrap";
import { useEffect, useState, useCallback } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import axios from "axios";
import toast from "react-hot-toast";
import ToastComponent from "./components/Toast/ToastComponent";

function App() {
  const [ladders, setLadders] = useState();
  const [loading, setLoading] = useState(true);
  const [tabs, setTabs] = useState();
  const [activeTab, setActiveTab] = useState();
  const [newPlayer, setNewPlayer] = useState(false);
  const [newPassword, setNewPassword] = useState(false)
  const [playername, setPlayername] = useState();

  const searchParams = new URLSearchParams(window.location.search);
  const ladder = searchParams.get('ladder') || 0;
  const viewer = searchParams.get('viewer') || false;

  const closeNewPassword = () => setNewPassword(false);
  const closeNewPlayer = () => setNewPlayer(false);

  const setPassword = (pass) => {
    localStorage.setItem("auth", pass);
  }
  axios.defaults.withCredentials = true;

  const storeLadders = (_data) => {
    let updateLadder = () => {
      return axios.post('/setLadders', _data, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("auth")}`
        }
      })
        .then(({ data }) => {
          console.log("Status", data.status)
          if (data.status === 'ok') {
            return "Ladder Updated"
          } else {
            console.log('not updated', data, data.status)
            throw new Error("Update Failed")
          }
        })
    }
    toast.promise(updateLadder(), {
      loading: "Sending update",
      success: "Updated",
      error: "Update Failed"
    })

  }

  const addPlayer = () => {
    setNewPlayer(false);
    setLadders((prevData) => {
      let _data = { ...prevData }
      let _ladder = [..._data[activeTab], playername]
      _data[activeTab] = _ladder
      storeLadders(_data)
      return _data;
    });
  }

  const updateLadder = (json) => {
    let _json = JSON.parse(JSON.stringify(json))
    const ladderNames = Object.keys(_json);
    setTabs(ladderNames)
    setActiveTab(ladderNames[ladder])
    setLadders(_json)
  }

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };


  const moveRow = useCallback((ladder, dragIndex, hoverIndex) => {
    setLadders((prevData) => {
      let _data = { ...prevData }
      let _ladder = _data[ladder]
      const dragRow = _ladder[dragIndex];
      const newData = [..._ladder];
      newData.splice(dragIndex, 1);
      newData.splice(hoverIndex, 0, dragRow);
      _data[ladder] = newData
      storeLadders(_data)
      return _data;
    });
  }, []);

  const TableRow = ({ ladder, player, index }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
      type: 'ROW',
      item: { id: player, index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }));

    const [, drop] = useDrop(() => ({
      accept: 'ROW',
      hover: (draggedItem, monitor) => {
        if (draggedItem.index === index) return;
        moveRow(ladder, draggedItem.index, index);
        draggedItem.index = index;
      },
    }));

    return (
      <tr
        ref={(node) => drag(drop(node))}
        style={{ opacity: isDragging ? 0.5 : 1 }}
      >
        <td>{index + 1}</td>
        <td className="player">{player}</td>
      </tr>
    );
  };

  function Ladders() {

    return (
      <Tabs defaultactivekey={`${tabs[ladder]}`} id="ladders" activeKey={activeTab} onSelect={handleTabSelect}>
        {tabs.map((_ladder) => (
          <Tab key={_ladder} eventKey={`${_ladder}`} title={`${_ladder}`}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Player</th>
                </tr>
              </thead>
              <tbody>
                {ladders[_ladder].map((player, index) => (
                  <TableRow key={index} player={player} ladder={_ladder} index={index} />
                ))}
              </tbody>
            </Table>
            {viewer ?
            <></>
            :
              <div className="align-right"><Button variant="danger" size="sm" onClick={() => localStorage.getItem("auth") ? setNewPlayer(true) : setNewPassword(true)}>+</Button></div>
            }
          </Tab>
        ))}
      </Tabs>
    )
  }

  useEffect(() => {
    async function fetchData() {
      axios.get(`/ladders`)
        .then(({ data }) => {
          updateLadder(data);
          setLoading(false)
        })
    }
    fetchData()
  }, [])

  if (loading) {
    return (
      <div>Loading...</div>
    )
  }

  return (
    <div className="App App-header">
      <ToastComponent />
      <img src={logo} alt="BSC Squash Club Logo" />
      <Panel>
        <Ladders />
      </Panel>

      <Modal show={newPlayer} onHide={closeNewPlayer}>
        <Modal.Header closeButton>
          <Modal.Title>New Player</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Add New Player</p>
          <input value={playername} onChange={(e) => setPlayername(e.target.value)} />
          <Button onClick={() => addPlayer(playername)} size="sm">Add</Button>
        </Modal.Body>
      </Modal>

      <Modal show={newPassword} onHide={closeNewPassword}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Password</p>
          <input value={localStorage.getItem("auth")} onChange={(e) => setPassword(e.target.value)} />
          <Button onClick={() => closeNewPassword()} size="sm">Set</Button>
        </Modal.Body>
      </Modal>

    </div>
  );
}

export default App;
